(() => {
  const root = document.querySelector('[data-momway-welcome]');
  if (!root) return;
  const panel = root.querySelector('[data-welcome-panel]');
  const launcher = root.querySelector('[data-welcome-open]');
  const close = root.querySelector('[data-welcome-close]');
  const success = root.querySelector('[data-welcome-success]');
  const errors = root.querySelector('[data-welcome-error]');
  const prefix = 'momway-newsletter-offer-v1:';
  const read = key => { try { return window.localStorage.getItem(prefix + key); } catch { return null; } };
  const write = (key, value) => { try { window.localStorage.setItem(prefix + key, String(value)); } catch {} };
  const until = key => Number(read(key) || 0) > Date.now();
  const remember = (key, days) => write(key, Date.now() + days * 86400000);
  const setOpen = (open, focus = false) => {
    panel.hidden = !open;
    launcher.hidden = open;
    launcher.setAttribute('aria-expanded', String(open));
    if (focus) (open ? close : launcher).focus();
  };
  const dismiss = () => {
    remember('dismissed', 30);
    setOpen(false, true);
  };
  launcher.addEventListener('click', () => setOpen(true, true));
  close.addEventListener('click', dismiss);
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); dismiss(); }
  });
  if (success) {
    remember('registered', 365);
    root.hidden = false;
    setOpen(true);
    const copy = root.querySelector('[data-welcome-copy]');
    const status = root.querySelector('[data-welcome-status]');
    copy.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(copy.dataset.code);
        status.textContent = copy.dataset.copied;
      } catch {
        status.textContent = copy.dataset.copyFailed;
      }
    });
    return;
  }
  if (errors) { root.hidden = false; setOpen(true); return; }
  if (root.dataset.knownSubscriber === 'true') { remember('registered', 365); return; }
  if (until('registered') || until('dismissed')) return;
  const visible = element => {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0 && rect.left < innerWidth && rect.right > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
  };
  const blocked = () => [...document.querySelectorAll('[role="dialog"][aria-modal="true"]:not([aria-hidden="true"]), dialog[open], #kaching-cart')].some(visible);
  const openedAt = Date.now();
  function reveal() {
    if (document.visibilityState !== 'visible' || blocked()) {
      if (Date.now() - openedAt < 60000) setTimeout(reveal, 1000);
      return;
    }
    root.hidden = false;
    if (until('shown')) return;
    remember('shown', 7);
    setOpen(true);
  }
  setTimeout(reveal, 8000);
})();
